import { EViewShiftSummary } from './chunk-DUMQLZJJ.mjs';
import { i18n_config_default } from './chunk-SGCJ7UYI.mjs';

// src/helpers/settings/roles.ts
var {
  valueToViewShiftSummary,
  viewShiftSummaryToValue,
  viewShiftSummaryOptions
} = Object.values(EViewShiftSummary).reduce(
  (acc, key, index) => {
    acc.valueToViewShiftSummary[index + 1] = key;
    acc.viewShiftSummaryToValue[key] = index + 1;
    acc.viewShiftSummaryOptions.push({
      value: index + 1,
      label: i18n_config_default.t(
        `settingsModule.roleDetailsSettings.endOfDay.endOfDayPermissions.viewShiftSummary.options.${key}`
      )
    });
    return acc;
  },
  {
    valueToViewShiftSummary: {},
    viewShiftSummaryToValue: {},
    viewShiftSummaryOptions: []
  }
);

export { valueToViewShiftSummary, viewShiftSummaryOptions, viewShiftSummaryToValue };
